import { z } from 'zod'

export type DisplaySettingsFormValues = z.infer<
  typeof DisplaySettingsFormSchema
>
export const DisplaySettingsFormSchema = z.object({
  colors: z.any(),
  audioCountdownSound: z.string(),
  audioCountdownVolume: z.any(),
  showEmojis: z.boolean(),
  emojis: z
    .string()
    .min(1, { message: 'At least one emoji should be defined' })
    .emoji(),
})
